import React from "react";

const InvitePage = () => {
  return (
    <div className="invite-page-wrapper">
      <div className="invite-page-container">
        <div className="details-container">
          <div className="business-email-details text-center">
            <h1>No Business Email? No Problem!</h1>
            <p>
              You can still hit us up with your ideas and needs at
              <br />
              hello@sooricorporation.com. We’re all ears!
            </p>
          </div>
        </div>
        <div className="details-container">
          <div className="join-us-details text-center">
            <h1>Join the Adventure!</h1>
            <p>
              Got career dreams? Shoot us an email at careers@sooricorp.com,
              <br /> or click here to explore our open positions. Let’s shape
              the future together!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitePage;
